import styled from '@emotion/styled';

import ZINDEX from '../../styles/emotion/zIndex';

export const Canvas = styled.canvas`
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
  z-index: ${ZINDEX.super};
  background-color: transparent;
`;
